import type { JobCardSkill } from '@/components/job-card'
import type { OpportunitySkill } from '@/hooks/use-opportunities'
import {
  tenantOrganisationLogoFallback,
  type OrganisationLogoSource,
} from '@/lib/candidate-org-logo'

export function mapOpportunitySkillsForCard(
  skills?: OpportunitySkill[] | null,
): JobCardSkill[] {
  if (!skills?.length) return []
  return skills.map((skill) => ({ id: skill.id, name: skill.skill_name }))
}

export function resolveOpportunityOrganisationLogoUrl(
  opportunity: OrganisationLogoSource & { organisation_logo_url?: string | null },
  tenantLogoFallbackSrc?: string,
): string | undefined {
  return (
    opportunity.organisation_logo_url?.trim() ||
    tenantOrganisationLogoFallback(opportunity, tenantLogoFallbackSrc)
  )
}
